import React, { useEffect, useRef, useState } from "react";
import { Option } from "../../Components/Option";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faArrowUp19,
  faArrowUp91,
  faArrowUpAZ,
  faClose,
  faSort,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";

export default function FilterData(props) {
  const { functions } = useSelector((state) => state);
  const { renderInput } = functions;
  const [isSort, setSort] = useState("asc");
  const [menuIsOpen, setMenuIsOpen] = useState(true);
  const ref = useRef();
  const {
    dataFilter,
    setFilterWidth,
    filterWidth,
    handleInputChange,
    onChange,
    dataCal,
    isRegexSearching,
    setTableFilter,
    index,
    popupTable,
    idModal,
    isParam
  } = props;
  const handleSortOrder = () => {
    setSort((prev) => (prev === "asc" ? "desc" : "asc"));
    onChange(isSort === "asc" ? "desc" : "asc");
  };

  return (
    <>
      {dataFilter &&
        dataFilter.map(
          ({
            field,
            handleInputChange,
            searchValues,
            search,
            handleKeyDown,
            label,
            isSelect,
            isRegexSearching,
            isRefresh,
            widthRef,
            lang,
            currentWidth,
          }) => {
            const datatype = field?.DATATYPE;
            const value = searchValues[label] || "";

            switch (datatype) {
              case "DATE":
              case "DATETIME":
                return (
                  <div
                    className="card date"
                    style={{
                      borderRadius: "5px",
                      boxShadow: "rgb(204, 204, 204) 1px 1px 10px 1px",
                    }}
                  >
                    <div
                      className="pr-2 d-flex align-items-center justify-content-between mb-1"
                      style={{ padding: "10px" }}
                    >
                      <div>
                        {lang["sorted"]}:
                        {isSort === "asc" ? (
                          <FontAwesomeIcon
                            icon={faArrowUp91}
                            style={{ marginLeft: "5px" }}
                            onClick={handleSortOrder}
                            fontSize={18}
                            color="#0056b3"
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={faArrowUp19}
                            style={{ marginLeft: "5px" }}
                            onClick={handleSortOrder}
                            fontSize={18}
                            color="#0056b3"
                          />
                        )}
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <i
                          className="fa fa-close"
                          style={{
                            fontSize: "22px",
                            color: "rgb(255, 102, 85)",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setTableFilter((prev) => ({
                              [index]: !prev[index],
                            }))
                          }
                        ></i>
                      </div>
                    </div>
                    <div className="input-search row m-0 p-2">
                      <label
                        className="form-label"
                        htmlFor={field.field_name}
                        style={{ color: "#888787" }}
                      >
                        {lang["log.daystart"]}:
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        placeholder={field.field_name}
                        name={field.field_name}
                        value={value?.from}
                        onChange={(e) => {
                          const { target } = e;
                          handleInputChange(
                            e,
                            field.fomular_alias,
                            { from: target.value, to: value?.to },
                            search,
                            label,
                            isRegexSearching
                          );
                        }}
                      />
                    </div>
                    <div className="input-search row m-0 p-2">
                      <label
                        className="form-label"
                        htmlFor={field.field_name}
                        style={{ color: "#888787" }}
                      >
                        {lang["log.dayend"]}:
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        placeholder={field.field_name}
                        name={field.field_name}
                        value={value?.to}
                        onChange={(e) => {
                          const { target } = e;
                          handleInputChange(
                            e,
                            field.fomular_alias,
                            { from: value?.from, to: target.value },
                            search,
                            label,
                            isRegexSearching
                          );
                        }}
                      />
                    </div>
                  </div>
                );
            }
            return (
              <div
                className="card"
                style={{
                  border: "none",
                  height: "395px",
                  boxShadow: "rgb(204, 204, 204) 1px 1px 10px 1px",
                  borderRadius: "5px",
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-between mb-1"
                  style={{ padding: "10px" }}
                >
                  <span>
                    {lang["sorted"]}:
                    {isSort === "asc" ? (
                      <FontAwesomeIcon
                        icon={faArrowUp91}
                        style={{ marginLeft: "5px" }}
                        onClick={handleSortOrder}
                        fontSize={18}
                        color="#0056b3"
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faArrowUp19}
                        style={{ marginLeft: "5px" }}
                        onClick={handleSortOrder}
                        fontSize={18}
                        color="#0056b3"
                      />
                    )}
                  </span>
                  {/* <FontAwesomeIcon icon={faSort} onClick={handleSortOrder} /> */}
                  <div style={{ textAlign: "right" }}>
                    <i
                      className="fa fa-close"
                      style={{
                        fontSize: "22px",
                        color: "rgb(255, 102, 85)",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setTableFilter((prev) => ({
                          [index]: !prev[index],
                        }))
                      }
                    ></i>
                    {/* <FontAwesomeIcon
                      icon={faClose}
                      color="red"
                      fontSize={25}
                      
                    /> */}
                  </div>
                </div>
                <Option
                  field={field}
                  label={""}
                  onChange={(data) => {
                    handleInputChange(
                      {},
                      field.fomular_alias,
                      data,
                      search,
                      label,
                      isRegexSearching
                    );
                  }}
                  primary_key={field.id}
                  table_id={field.table_id}
                  widthRef={widthRef}
                  setFilterWidth={setFilterWidth}
                  currentWidth={currentWidth}
                  handleInputChange={handleInputChange}
                  dataCal={dataCal}
                  isRegexSearching={isRegexSearching}
                  menuIsOpen={menuIsOpen}
                  popupTable={popupTable}
                  idModal={idModal}
                  isParam={isParam}
                />
              </div>
            );
            // ) : (
            //   functions.renderInput(
            //     field,
            //     handleInputChange,
            //     searchValues,
            //     search,
            //     handleKeyDown,
            //     label,
            //     isSelect,
            //     isRegexSearching,
            //     isRefresh,
            //     widthRef,
            //     lang
            //   )
            // );
          }
        )}
    </>
  );
}
